module.exports = __webpack_public_path__ + "img/square-green.3956ef68.svg";